import { stringify } from "querystring";

import {
  MEMBERSHIP_REBUY_PREFILL_PARAM,
  MembershipRebuyBuyerDetailsInput,
  storeMembershipRebuyPrefill,
} from "./membershipRebuyPrefill";

import { TicketPurchase } from "@/common/types/ticketing";

export const MEMBER_FOR_QUERY_PARAM = "memberFor";
export const MEMBER_FOR_SOMEONE_ELSE = "other";

export interface MembershipRebuy {
  rateId: string;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  buyerDetails?: MembershipRebuyBuyerDetailsInput;
}

export const getMembershipRebuy = ({
  isMemberInfoEnabled,
  allowsMultipleMemberships,
  ticketsPurchased,
  addOnRateIds,
  buyer,
}: {
  isMemberInfoEnabled: boolean;
  allowsMultipleMemberships: boolean;
  ticketsPurchased: Pick<TicketPurchase, "rateId" | "purchasedNumber">[] | undefined;
  addOnRateIds: Set<string>;
  buyer: Omit<MembershipRebuy, "rateId">;
}): MembershipRebuy | null => {
  if (!isMemberInfoEnabled || allowsMultipleMemberships) {
    return null;
  }

  const boughtMemberships = (ticketsPurchased ?? []).filter(
    (ticket) => (ticket.purchasedNumber ?? 0) > 0 && !addOnRateIds.has(ticket.rateId)
  );
  if (boughtMemberships.length !== 1) {
    return null;
  }

  return { rateId: boughtMemberships[0].rateId, ...buyer };
};

export const buildMembershipRebuyUrl = (formUrl: string, rebuy: MembershipRebuy): string => {
  const prefillToken = rebuy.buyerDetails
    ? storeMembershipRebuyPrefill(formUrl, rebuy.rateId, rebuy.buyerDetails)
    : undefined;
  const params = stringify({
    rateId: rebuy.rateId,
    [MEMBER_FOR_QUERY_PARAM]: MEMBER_FOR_SOMEONE_ELSE,
    ...(rebuy.firstName ? { firstName: rebuy.firstName } : {}),
    ...(rebuy.lastName ? { lastName: rebuy.lastName } : {}),
    ...(rebuy.email ? { email: rebuy.email } : {}),
    ...(prefillToken ? { [MEMBERSHIP_REBUY_PREFILL_PARAM]: prefillToken } : {}),
  });

  return `${formUrl}${formUrl.includes("?") ? "&" : "?"}${params}`;
};
